import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from '../../../../component/Tabs/Tab';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';
import { fetchData } from '../../../../helpers/ApiUtils';

const Assets = () => {
  const navigate = useNavigate();
  const [keys, setKeys] = useState([]);
  const [columns, setColumns] = useState([]);

  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [isNextPage, setIsNextPage] = useState(true);

  const [data, setData] = useState([]);
  const [loading, setLoadingData] = useState(true);
  const [error, setError] = useState(null);

  const [filterKeyword, setFilterKeyword] = useState("");

  const [activeType, setActiveType] = useState("pending-assets");

  const tabHeader = [
    {
      "key": "pending-assets",
      "label": "Aset Tertunda",
    },
    {
      "key": "active-assets",
      "label": "Aset Aktif"
    },
    {
      "key": "sold-assets",
      "label": "Dijual/Dilepas"
    },
    {
      "key": "depreciation",
      "label": "Penyusutan"
    }
  ];

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ASSET = "api/erpppsu/asset";

  useEffect(() => {
    setLoadingData(true);
    fetchData(`${BASE_URL}${PATH_ASSET}?type=${activeType}`, {
      params: {
        offset: pageIndex,
        limit: pageSize
      }
    }, setLoadingData, setError).then((data) => {
      setData(data.data);
      setTotalRows(data.total);
    });
  }, [activeType]);

  useEffect(() => {
    setKeys(data.length > 0 ? Object.keys(data[0]) : []);
  }, [data]);

  useEffect(() => {
    setColumns(keys.map(key => ({
      Header: key.charAt(0).toUpperCase() + key.slice(1),
      accessor: key
    })));
  }, [keys]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (filterKeyword) {
        // fetchData(`${BASE_URL}${PATH_SALES}/find`, {
        //   params: {
        //     type: activeType,
        //     date: filterDate,
        //     keyword: filterKeyword,
        //   }
        // }).then((data) => {
        //   setData(data.data);
        //   setTotalRows(data.total);
        // });
      }
    }, 500);

    return () => clearTimeout(handler);

  }, [filterKeyword]);


  const handleTabClick = (tab) => {
    setActiveType(tab);
  };

  // const options = [
  //   { value: 'invoice', label: 'Penagihan Penjualan' },
  //   { value: 'order', label: 'Pemesanan Penjualan' },
  //   { value: 'quote', label: 'Penawaran Penjualan' }
  // ];

  const handleDetail = (rowData) => {
    navigate(`/activity-erpppsu/sales/detail/${rowData.id.value}`);
  };

  const actions = [{
    child: <button className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
      <FontAwesomeIcon icon={faInfo} color="white" />nfo
    </button>,
    callback: (rowData) => handleDetail(rowData)
  }];

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div className='flex items-center justify-between'>
        <h2 className="text-2xl font-bold mb-4">Manajemen Aset</h2>

        <div className='flex items-center'>
          {/* <ButtonOptionGroup
            label={"Buat Penjualan Baru"}
            options={options}
            onChange={(value) => {
              navigate(`/activity-erpppsu/sales/new/${value}`);
            }}
          /> */}
        </div>
      </div>

      <div className="tabs flex justify-between">
        <div className="">
          {tabHeader.map((tab) => (
            <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
              handleTabClick(tab.key)
            }} />
          ))}

        </div>

        <div className="">
          <input
            id="keyword"
            name="keyword"
            type="text"
            autoComplete='off'
            className="my-1 p-1 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            placeholder='Ketik disini'
            defaultValue={filterKeyword}
            onChange={(e) => setFilterKeyword(e.target.value)}
          />

        </div>
      </div>

      {/* <div className="container m-auto grid grid-cols-4 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 my-3 gap-4">
        <div className="">
          <label htmlFor="keyword" className="block mb-1 text-sm font-semibold">No. Transaksi / Pelanggan / Tags</label>
          <input
            id="keyword"
            name="keyword"
            type="text"
            autoComplete='off'
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            placeholder='Ketik disini'
            defaultValue={filterKeyword}
            onChange={(e) => setFilterKeyword(e.target.value)}
          />
        </div>
      </div> */}

      {loading ? (
        <center><h1>Loading...</h1></center>
      ) : (
        <DataTablePageDynamic
          data={data}
          nextPage={isNextPage}
          columns={columns}
          elementClass="p-1"
          actions={actions}
          pageSize={pageSize}
          onDataChange={(pageIndex, pageSize, sortBy) => {
            // setPageIndex(pageIndex);
            // fetchData(`${BASE_URL}${PATH_ASSET}?type=${activeType}`, {
            //   params: {
            //     offset: pageIndex,
            //     limit: pageSize
            //   }
            // }).then((data) => {
            //   setIsNextPage(data.more > 0);
            //   setData(data.data);
            //   setTotalRows(data.total);
            // });
          }} />
      )}

      {activeType == 'pending-assets' && <div className="bg-gray-100 text-center py-6 rounded-md shadow-sm">
        <h2 className="text-blue-700 text-lg font-semibold mb-1">
          Anda tidak punya aset tertunda untuk disimpan
        </h2>
        <p className="text-gray-700">
          Baru saja membeli aset baru?{" "}
          <a href="/activity-erpppsu/purchases/new" className="text-blue-600 hover:underline">
            Tambahkan di sini
          </a>
        </p>
        <p className="text-gray-700">
          Sudah ada sebelum bermigrasi ke Sistem Ini?{" "}
          <a href="/activity-erpppsu/asset-management/new" className="text-blue-600 hover:underline">
            Simpan di sini
          </a>
        </p>
      </div>}

      <p>
        Menampilkan {Math.min(pageSize + pageIndex, totalRows)} dari {totalRows} Baris
      </p>
    </div>
  )
}

export default Assets;
